<script lang="ts" setup>
import { computed } from 'vue'
import { Select } from '@brighterly/lib-lumee-ui'

import type { IconName, SelectOption } from '@brighterly/lib-lumee-ui'

import { whenSelected } from '@shared/lib/select'

defineOptions({
  name: 'LessonRoomDeviceSelect',
})

const props = defineProps<{
  label: string
  icon: IconName
  options: { deviceId: string, label: string }[]
  modelValue: string
}>()

const emit = defineEmits<{
  'update:modelValue': [string]
}>()

const items = computed<SelectOption[]>(() => props.options.map(({ deviceId, label }) => ({ value: deviceId, text: label })))

const handleChange = whenSelected((deviceId: string) => emit('update:modelValue', deviceId))
</script>

<template>
  <Select
    :label="label"
    :leading-icon="icon"
    :items="items"
    :model-value="modelValue"
    @update:model-value="handleChange"
  />
</template>
